import { injectable } from 'inversify';

export interface ZipEntry {
  name: string;
  content: Promise<Blob>;
}

@injectable()
export class ZipGeneratorService {
  /**
   * @param zipEntries
   * @param options
   * @param options.onUpdate callback permettant de savoir le pourcentage de complétion de la génération du zip (entre 0 et 100)
   */
  public async generateZipContent(
    zipEntries: AsyncIterable<ZipEntry>,
    options: { onUpdate?: (completionPercentage: number) => void } = {},
  ): Promise<Blob> {
    options.onUpdate?.(0);

    const { default: JSZip } = await import('jszip');
    const zip = new JSZip();

    for await (const zipEntry of zipEntries) {
      zip.file(zipEntry.name, zipEntry.content);
    }

    return await zip.generateAsync(
      {
        type: 'blob',
        streamFiles: true,
      },
      (metadata) => {
        options.onUpdate?.(metadata.percent);
      },
    );
  }
}
